import React, { FC } from 'react'

import { Button, ButtonVariants } from '@inno-ui/button'
import { ArrowRightIcon } from '@inno-ui/icons'

import { TourNavigationButtonProps } from './TourNavigationButton.types'

export const TourNavigationButton: FC<TourNavigationButtonProps> = props => {
  return (
    <Button
      {...props}
      variant={ButtonVariants.Ghost}
      icon={props.icon || ArrowRightIcon}
    />
  )
}
